export default __webpack_public_path__ + "static/media/cool.bba3cd17.svg";